import Env from '../config/env';

export const getSnowdenURL = (id: string) =>
  `${Env.PAYMENT_HOST}/?callback_url=${Env.REQUEST_CAIPIRINHA_HOST}/v1/cards/${id}`;
